import { render, staticRenderFns } from "./ComplieRightMenuFood.vue?vue&type=template&id=e51ed3fa&scoped=true"
import script from "./ComplieRightMenuFood.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuFood.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuFood.vue?vue&type=style&index=0&id=e51ed3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51ed3fa",
  null
  
)

export default component.exports